import ParameterValidator from '@mvps-genesis/parameter-validator';

export class AnchorSmoothScroll {
	static createFromSelector (selector = '[data-smooth-scroll]') {
		const elements = document.querySelectorAll(selector);

		return Array.from(elements)?.map(element => {
			return new this(element);
		});
	}

	constructor (elementOrSelector) {
		this._validator = new ParameterValidator(this);

		/**
		 * @type {HTMLElement}
		 */
		this.element = this._validator.isElement('elementOrSelector', elementOrSelector);

		this.handleClick = this._handleClick.bind(this);

		this.addEvents();
	}

	/**
	 * @param {string} href
	 */
	getIdFromHref (href) {
		const [, id] = href.match(/#([\d\w\-_]+)/i);

		return id;
	}

	/**
	 * @param {Event} e
	 */
	_handleClick (e) {
		e.preventDefault();

		const id = this.getIdFromHref(this.element.href);
		const target = document.getElementById(id);

		if (target) {
			target.scrollIntoView({
				behavior: 'smooth'
			});
		}
	}

	addEvents () {
		this.element.addEventListener('click', this.handleClick);
	}

	removeEvents () {
		this.element.removeEventListener('click', this.handleClick);
	}
};

